import { IChartData } from "@/models/Charts/ChartData";
import { RepairOrder } from "@/services/api";
import _ from "lodash";
import * as React from "react";
import format from "date-fns/format";
import addMonths from "date-fns/addMonths";
import { BarChart } from "../../molecules/Charts/BarChart";
import Rand from "rand-seed";
export interface IRosByMonthProps {
	repairOrders: RepairOrder[];
	loading?: boolean;
	title?: string;
}

export function RosByMonth({ repairOrders, loading, title }: IRosByMonthProps) {
	const chartData = React.useMemo<IChartData>(() => {
		if (loading) {
			const date = new Date();
			const labels = Array.from(Array(6).keys()).map((i, index) => {
				const m = addMonths(date, -5 + i);
				return format(m, "MMM yyyy");
			});
			const rand = new Rand("submitted");
			const cd: IChartData = {
				key: "loading-data",
				items: [
					{
						label: "Submitted",
						values: labels.map((i) => Math.round(rand.next() * 10)),
						color: "#eee",
					},
					{
						label: "Scheduled",
						values: labels.map((i) => Math.round(rand.next() * 10)),
						color: "#eee",
					},
					{
						label: "Vehicle Out",
						values: labels.map((i) => Math.round(rand.next() * 10)),
						color: "#eee",
					},
				],
				labels,
			};

			return cd;
		}

		const dates = _.uniq(
			repairOrders
				.flatMap((i) =>
					[i.requestSubmitted!, i.requestScheduled!, i.requestCompleted!].filter((i) => i)
				)

				.sort((a, b) => format(a, "yyyy-MM").localeCompare(format(b, "yyyy-MM")))
				.map((i) => format(i, "MMM yyyy"))
		);

		const cd: IChartData = {
			items: [
				{
					label: "PCS Submitted",
					values: dates.map(
						(date) =>
							repairOrders.filter(
								(i) => !!i.requestSubmitted && date === format(i.requestSubmitted, "MMM yyyy")
							).length
					),
				},
				{
					label: "PCS Scheduled",
					values: dates.map(
						(date) =>
							repairOrders.filter(
								(i) => !!i.requestScheduled && date === format(i.requestScheduled, "MMM yyyy")
							).length
					),
				},
				{
					label: "PCS Completed",
					values: dates.map(
						(date) =>
							repairOrders.filter(
								(i) => !!i.requestCompleted && date === format(i.requestCompleted, "MMM yyyy")
							).length
					),
				},
			],
			labels: dates,
		};

		return cd;
	}, [repairOrders, loading]);

	return <BarChart title={title} showLegend data={chartData} />;
}
